import * as Types from "../Constants/AllConstants";

// =============== EMAIL PACKAGES ===============
export const OpenEmailPackagesReducer = (state = { packages: [] }, action) => {
  switch (action.type) {
    case Types.OPEN_EMAIL_PACKAGES_REQUEST:
      return { loading: true };
    case Types.OPEN_EMAIL_PACKAGES_SUCCESS:
      return { loading: false, packages: action.payload };
    case Types.OPEN_EMAIL_PACKAGES_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

export const OpenEmailPackagesFullReducer = (state = { packages: [] }, action) => {
  switch (action.type) {
    case Types.OPEN_EMAIL_PACKAGES_FULL_REQUEST:
      return { loading: true };
    case Types.OPEN_EMAIL_PACKAGES_FULL_SUCCESS:
      return { loading: false, packages: action.payload };
    case Types.OPEN_EMAIL_PACKAGES_FULL_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

export const OpenSmsPackagesReducer = (state = { packages: [] }, action) => {
  switch (action.type) {
    case Types.OPEN_SMS_PACKAGES_REQUEST:
      return { loading: true };
    case Types.OPEN_SMS_PACKAGES_SUCCESS:
      return { loading: false, packages: action.payload };
    case Types.OPEN_SMS_PACKAGES_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

export const OpenSmsPackagesFullReducer = (state = { packages: [] }, action) => {
  switch (action.type) {
    case Types.OPEN_SMS_PACKAGES_FULL_REQUEST:
      return { loading: true };
    case Types.OPEN_SMS_PACKAGES_FULL_SUCCESS:
      return { loading: false, packages: action.payload };
    case Types.OPEN_SMS_PACKAGES_FULL_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};
